<i class="float-right fas fa-search cursor-pointer" (click)="toggleFilter()"></i>
<div class="w-100 float-left" *ngIf="showFilter">
    <input class="form-control search-input mb-2" placeholder="Search" [(ngModel)]="filter" (input)="searchTrigger.execute()"/>
</div>